import { useState, useCallback, useEffect } from "react";

const PROGRESS_MAX = 100;

// When active is true, a timer starts and progess increases from 0-100
// Return arguments are [hidden, hide, progress], where hide can be called
// to trigger onDeactivate early and stop the timer.
export default function useDismissableAutohider(
  shown: boolean,
  setHidden: () => void,
  delay: number,
  steps: number
): [() => void, number] {
  const [step, setStep] = useState(0);
  const hide = useCallback(() => {
    setStep(0);
    setHidden();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let frameId: number | undefined;
    const start = Date.now();

    function tick() {
      const elapsed = Date.now() - start;
      if (elapsed >= delay) {
        hide();
        return;
      }
      setStep((step) =>
        elapsed >= (delay / steps) * (step + 1) ? step + 1 : step
      );
      frameId = requestAnimationFrame(tick);
    }

    if (shown) {
      frameId = requestAnimationFrame(tick);
    }

    return () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
      setStep(0);
    };
    // eslint-disable-next-line
  }, [shown, delay, hide, steps]);

  return [hide, (step / steps) * PROGRESS_MAX];
}
